export const environment = {
  production: true,
  version: '2.8.0',
  ENVIRONMENT: 'prod',
  SHOW_RIBBON: false
};

export const URL = {
  url: 'https://hbi-portal.michelin.com/api/v1/', // for the prod
  users: 'users/',
  user: 'user/',
  applications: 'applications',
  upload: 'upload/',
  importFile: 'importFile',
  importFileXlsxStatus: 'importFileXlsxStatus/',
  controllers: 'controllers/',
  connectionsDb: 'connectionsDb/',
  scripts: 'scripts/',
  group: 'group/',
  table: 'table/',
  clientId: 'PROD-HBI',
  issuer: 'https://login-fed.michelin.com:443/am/oauth2'
};

export const BACKEND_URL = {
  url: 'https://hbi-portal.michelin.com/api/v1/' // it's for prod
};
